<template>
  <div>
    <ClientListing />
  </div>
</template>

<script>
import ClientListing from '@/components/Clients/listing/ClientsListing.vue'
export default {
  components: { ClientListing },
}
</script>
